import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

MembershipListOrganizationsController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'PermissionsService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'NoticeFactory',
  'ViewStateService',
];

function MembershipListOrganizationsController(
  $scope,
  $state,
  $timeout,
  $filter,
  $uibModal,
  ApiService,
  CalendarService,
  HelpersService,
  PermissionsService,
  GridStateFactory,
  GridDefinitionFactory,
  NoticeFactory,
  ViewStateService
) {
  $scope.membershipListOrganizations = {
    model: [],
    filtered: [],
    searchQuery: '',
    isLoaded: false,
    queryTimer: false,
    viewId: '',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    membershipListOrganizationsGridName: $state.current.name + '.cardholders.grid0',

    optionsOverride: {
      rowHeight: 40,
      data: 'membershipListOrganizations.filtered',
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize) {
          $scope.membershipListOrganizations.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridSortChange: function (grid, columns, page) {
          $scope.membershipListOrganizations.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          $scope.membershipListOrganizations.onDblClick(item);
        },
      },
      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          width: 50,
          onCellNavClick: function (row, col) {
            $scope.membershipListOrganizations.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.orgName }}</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'externalMembershipId',
          displayName: 'Membership Id',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'orgName',
          displayName: 'Organization Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'orgId',
          displayName: 'Organization Id',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'membershipStanding',
          displayName: 'Membership Standing',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'name',
          displayName: 'Name on Card',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'email',
          displayName: 'Email',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'cardType',
          displayName: 'Card Type',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'streetAddress1',
          displayName: 'Address',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'city',
          displayName: 'City',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'state',
          displayName: 'State',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'zipCode',
          displayName: 'Zip',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipJoinedDateDisplay',
          displayName: 'Joined',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipExpirationDateDisplay',
          displayName: 'Expires',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'category',
          displayName: 'Category',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'subcategory',
          displayName: 'Subcategory',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipCategory',
          displayName: 'ACME Level',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'barcode',
          displayName: 'External Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeBarcode',
          displayName: 'ACME Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeCustomerNumber',
          displayName: 'ACME Customer Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeMembershipNumber',
          displayName: 'ACME Membership Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'constituentId',
          displayName: 'Constituent Id',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'externalConstituentId',
          displayName: 'External Constituent Id',
          headerTooltip: true,
          visible: false,
        },
      ],
    },

    init: function () {
      this.viewId = $state.current.name;

      this.gridDefinition.init(
        this.membershipListOrganizationsGridName,
        this.optionsOverride,
        this.viewId,
        $state.current.data.enablePreferences
      );

      this.restoreViewState();

      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      $scope.$on('MembershipListController::Search', this.onMembershipListControllerSearch);
    },

    initData: function () {
      const self = $scope.membershipListOrganizations;
      const props = self.gridDefinition.getGridState();

      self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);

      self.getMembers(self.gridState.getGridState());
    },

    updateState: function () {
      const state = {
        page: this.gridState.getPropertyValue('page'),
        pageSize: this.gridState.getPropertyValue('pageSize'),
        search: this.searchQuery,
      };

      ViewStateService.setState('membership.list', state);
    },

    restoreViewState: function () {
      const viewState = ViewStateService.getState('membership.list');

      if (viewState.page) {
        this.gridState.setPropertyValue('page', viewState.page);
        this.gridDefinition.setPageNumber(viewState.page);
        this.gridState.setPropertyValue('pageSize', viewState.pageSize);
      }

      if (viewState.search) {
        this.gridState.setPropertyValue('search', viewState.search);
      }
    },

    getMembers: function (page) {
      const props = page;
      props.corporate = true;
      props.cardType = this.searchCardholders;

      this.blockQuery = true;
      this.isLoaded = false;
      this.gridDefinition.isLoaded = false;
      $scope.$emit('MembershipList::Loaded', { isLoaded: this.gridDefinition.isLoaded });

      ApiService.membership.summaries.search(props).then(this.success.getMembers, this.error.getMembers);
    },

    query: function () {
      const self = $scope.membershipListOrganizations;

      self.gridState.setPropertyValue('search', this.searchQuery);

      if (this.queryTimer) {
        $timeout.cancel(this.queryTimer);
      }

      this.queryTimer = $timeout(function () {
        $scope.$broadcast('DataGrid::Search', { name: self.membershipListOrganizationsGridName });
      }, 300);
    },

    search: function () {
      this.filtered = $filter('filter')(this.filtered, function (member) {
        const number = member.externalMembershipId || '';
        const name = member.name || '';
        const email = member.email || '';
        const value = (number + name + email).toLowerCase();
        console.log(
          'ProgramsController::search',
          member.name,
          $scope.membershipListOrganizations.searchQuery,
          value.indexOf($scope.membershipListOrganizations.searchQuery.toLowerCase()) !== -1
        );
        return value.indexOf($scope.membershipListOrganizations.searchQuery.toLowerCase()) !== -1 ? member : null;
      });
    },

    process: function (members) {
      if (members instanceof Array) {
        for (let i = 0, ii = members.length; i < ii; i++) {
          members[i].membershipJoinedDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipJoinedDate),
            HelpersService.dateFormats.sortDate
          );
          members[i].membershipExpirationDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipExpirationDate),
            HelpersService.dateFormats.sortDate
          );
        }
      } else {
        members = [];
      }

      return members;
    },

    success: {
      init: function (response) {},
      getMembers: function (response) {
        const self = $scope.membershipListOrganizations;

        self.filtered = self.process(response.data.payload.list);

        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;
        self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);

        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.filtered.length,
            totalItems: self.gridState.getPropertyValue('totalItems'),
          });

          $scope.$emit('MembershipList::Loaded', { isLoaded: self.gridDefinition.isLoaded });

          $timeout(function () {
            self.blockQuery = false;
          }, 100);
        }, 10);
      },
    },

    error: {
      init: function (response) {},
      getMembers: function (response) {},
    },

    onDataGridSortChange: function (grid, columns, page) {
      const self = $scope.membershipListOrganizations;
      const data = columns[0];

      if (data) {
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        if (!self.blockQuery) {
          self.getMembers(self.gridState.getGridState());
        } else {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.filtered.length,
            totalItems: self.gridState.getPropertyValue('totalItems'),
          });
        }
      }
    },

    onDblClick: function (item) {
      // Create and edit are handled by the same controller
      this.updateState();
      console.log('MembershipListController::onGridDblClick', item.entity.orgId);
      $state.go('application.partners.detail', { id: item.entity.orgId });
    },

    onDataGridPaginate: function (newPage, pageSize) {
      const self = $scope.membershipListOrganizations;
      self.gridState.updateGridState(newPage, pageSize);
      if (!self.blockQuery) {
        self.getMembers(self.gridState.getGridState());
      } else {
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: self.gridDefinition.options.gridName,
          datasetLength: self.filtered.length,
          totalItems: self.gridState.getPropertyValue('totalItems'),
        });
      }
    },

    onDestroy: function () {
      if ($scope.membershipListOrganizations.queryTimer) {
        $timeout.cancel($scope.membershipListOrganizations.queryTimer);
      }
    },

    onMembershipListControllerSearch: function (e, data) {
      const self = $scope.membershipListOrganizations;
      if (data.searchType === 'organizations') {
        self.searchQuery = data.searchQuery;
        self.gridState.setPropertyValue('search', self.searchQuery);
        self.searchCardholders = data.searchCardholders ? 'secondary' : null;
        self.getMembers(self.gridState.getGridState());
      }
    },
  };

  $scope.membershipListOrganizations.init();
}

export const MembershipListOrganizationsControllerModule = angular
  .module('acme.view.application.membership.list.organizations.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.viewState',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.factory.notice',
  ])
  .controller('MembershipListOrganizationsController', MembershipListOrganizationsController).name;
